import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/theme.scss';
import './styles/defaults.css';
import App from './app';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
